export default function MobileAndroid(){
    return(<div>
        <img alt="" src="assets/android_filled.png" className="mobileAndroidFrame"/>
    </div>
    )
}